module.exports = __webpack_public_path__ + "static/media/discover_inActive.bdaa6aae.png";